import { render, staticRenderFns } from "./searchPropDetail.vue?vue&type=template&id=60dc241c&"
import script from "./searchPropDetail.vue?vue&type=script&lang=js&"
export * from "./searchPropDetail.vue?vue&type=script&lang=js&"
import style0 from "./searchPropDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports